var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.934 13.467C23.934 7.695 19.238 3 13.467 3C7.695 3 3 7.695 3 13.467C3 19.238 7.695 23.934 13.467 23.934C15.777 23.933 18.052 23.149 19.873 21.725L20.014 21.617L20.138 21.742L25.858 27.461L27.461 25.859L21.617 20.014L21.724 19.874C23.148 18.053 23.933 15.778 23.934 13.467ZM13.467 21.667C8.946 21.667 5.267 17.989 5.267 13.467C5.267 8.946 8.946 5.267 13.467 5.267C17.989 5.267 21.667 8.946 21.667 13.467C21.667 17.989 17.989 21.667 13.467 21.667Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSearch);
export default __webpack_public_path__ + "static/media/icons-search.6bbdf97f38a9658210df479b54e51125.svg";
export { ForwardRef as ReactComponent };